<!-- <div class="row m-4">
  <div class="col-md-3">
    <app-navbar></app-navbar>
  </div>
  <div class="col-md-4">
    <h1><i class="fa fa-box-open text-danger mr-1"></i> Package <strong>Manager </strong>
    </h1>
  </div>
</div> -->


<div class="container-fluid">

  <div class="row">
    <div class="col-md-3 ">

      <h3>Select files</h3>
      <input type="file" ng2FileSelect [uploader]="uploader" [disabled]='true' />
      <br>
      <br>
      <h6 style="color:blue;font-weight: bold;">* Uploading packages from here is currently disabled !</h6>
    </div>


    <div class="col-md-9" style="margin-bottom: 40px">

      <div class="col-sm-12">
        <ul class="nav nav-tabs" style="margin-top: 10px;">
          <li class="nav-item"><a (click)="getData()"
            class="nav-link active" style="cursor: pointer;background-color: gainsboro;">Refresh</a></li>
          <hr>
        </ul>
      </div>

      <h3 class="textAdjust">Packages available: {{ packagesAvailable.length }}</h3>

      <div>
        <mat-form-field class="col-sm-12">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="applyFilter($event)" placeholder="Filter value">
        </mat-form-field>
      </div>

      <table mat-table [dataSource]="tableData" class="col-sm-12 mat-elevation-z8" style="background-color: whitesmoke;"
        matSort>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="px-2" style="width:10%" mat-sort-header> ID </th>
          <td mat-cell *matCellDef="let element" class="px-2" style="width:10%"> {{element.id}} </td>
        </ng-container>

        <ng-container matColumnDef="file_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="justify-content: center;"> File Name </th>
          <td mat-cell *matCellDef="let element"> {{element.file_name}} </td>
        </ng-container>

        <ng-container matColumnDef="file_path">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> File Path </th>
          <td mat-cell *matCellDef="let element"> {{element.file_path}} </td>
        </ng-container>

        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> File Size </th>
          <td mat-cell *matCellDef="let element"> {{element.size}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>

      <mat-paginator [length]='packagesAvailable.length' [pageSize]='10' [pageSizeOptions]="[5, 10, 20]"
        showFirstLastButtons>
      </mat-paginator>
      <!-- <table class="table text-dark">
        <thead>
        <tr>
          <th width="50%">Name</th>
          <th>Size</th>
          <th>Progress</th>

          <th>Actions</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of uploader.queue">
          <td><strong>{{ item?.file?.name }}</strong></td>
          <td *ngIf="uploader.options.isHTML5" nowrap>{{ item?.file?.size / 1024 / 1024 | number:'.2' }} MB</td>
          <td *ngIf="uploader.options.isHTML5">
            <div class="progress" style="margin-bottom: 0;">
              <div class="progress-bar progress-bar-striped progress-bar-animated bg-danger" role="progressbar"
                   [ngStyle]="{ 'width': item.progress + '%' }"></div>
            </div>
          </td>
          <td class="text-center">
            <span *ngIf="item.isSuccess"><i class="glyphicon glyphicon-ok"></i></span>
            <span *ngIf="item.isCancel"><i class="glyphicon glyphicon-ban-circle"></i></span>
            <span *ngIf="item.isError"><i class="glyphicon glyphicon-remove"></i></span>
          </td>
          <td nowrap>
            <button type="button" mat-raised-button color="primary"
                    (click)="item.upload()" [disabled]="item.isReady || item.isUploading || item.isSuccess">
              Upload
            </button>
            <button type="button" mat-button
                    (click)="item.cancel()" [disabled]="!item.isUploading">
              Cancel
            </button>
            <button type="button" mat-button
                    (click)="item.remove()">
              Remove
            </button>
          </td>
        </tr>
        </tbody>
      </table> -->

      <!-- <div class="text-dark" [hidden]="!uploader.getNotUploadedItems().length ">
        <div class="mt-4 mb-4 p-4">
          Queue progress:
          <div class="progress" style="">
            <div class="progress-bar progress-bar-striped progress-bar-animated bg-danger" role="progressbar"
                 [ngStyle]="{ 'width': uploader.progress + '%' }"></div>
          </div>
        </div>
        <button mat-raised-button color="primary" type="button"
                (click)="uploader.uploadAll()" [disabled]="!uploader.getNotUploadedItems().length">
          Upload all
        </button>
        <button type="button" mat-button
                (click)="uploader.cancelAll()" [disabled]="!uploader.isUploading">
          Cancel all
        </button>
        <button type="button" mat-button
                (click)="uploader.clearQueue()" [disabled]="!uploader.queue.length">
          Remove all
        </button>
      </div>
      <div [hidden]="!show_alert_upload_status" role="alert" class="shadow m-4 p-4 ml-4 w-50 alert alert-success">
        {{show_alert_upload_msg}}
      </div>
    </div> -->

    </div>
